<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="row">

  <div class="columnnbv1">
    <div class="position-fixed-scans2 border-right2  height-100pe">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-right-0px">
        <!--<div class="row"></div>-->
        <div class="card height-100vh">
          <div>
            <a class="nav-link-hand  back-link left-arrow-treatmentcycle" title="Back To Admission" (click)="BackToAdmission()"><i class="fas fa-angle-double-left font-size-19px"></i></a>
          </div>
          <div class="card-header wh-header border-bottom padding-bottom-0px">
            <div class="row">
              <div class="col-md-12">
                <label class="margin-bottom-0px">Patient Admission</label>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row border-bottom-2px" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
              <!--<div class="padding-left-14px padding-right-14px padding-bottom-14px"></div>-->
              <!--<div class="card"></div>-->
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <img class="img-circle-50" [src]='l.PatientImageFile' onError="this.src='dummy.jpg';">
                    <!--<img class="img-circle-50" src="DR SITARAM.jpg" onError="this.src='dummy.jpg';">-->
                  </div>
                </div>
                <div class="row margin-left-zero margin-top-10">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{l.DisplayName}}</label>
                  </div>
                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{l.Gender}}/{{l.Age}}</label>
                  </div>
                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{l.FormattedCode}}</label>
                  </div>

                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{l.Telephone1}}</label>
                  </div>

                </div>

              </div>
            </div>

            <div class="row padding-top-10px" *ngIf="Tabslist">
              <div class="col-md-12 padding-left-3px padding-right-5px">

                <nav>
                  <div class="chatsd product-chart-wrapper product-chat-width-cyclestab agreement-chart-wrapper ps overflow-x-hidden padding-lrt " data-ps-id="dfsfsde">
                    <div class="nav nav-tabs  width-211px display-inherit border-bottom-0px">

                      <a class="nav-item nav-link link2 margin-left-17px border-bottom-light nav-link-hand" [class.active]="activeTab === 'admissiondetails'" (click)="activeTab = 'admissiondetails'">Admission Details<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                      <a class="nav-item nav-link link2 margin-left-17px border-bottom-light nav-link-hand" [class.active]="activeTab === 'services'" (click)="activeTab = 'services'">Services<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                      <a class="nav-item nav-link link2 margin-left-17px border-bottom-light nav-link-hand" [class.active]="activeTab === 'medicines'" (click)="activeTab = 'medicines'">Medicines<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                      <a class="nav-item nav-link link2 margin-left-17px border-bottom-light nav-link-hand" [class.active]="activeTab === 'consumption'" (click)="activeTab = 'consumption'">Consumption<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                      <a class="nav-item nav-link link2 margin-left-17px border-bottom-light nav-link-hand" [class.active]="activeTab === 'discharge'" (click)="activeTab = 'discharge'">Discharge<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                      <a class="nav-item nav-link link2 margin-left-17px border-bottom-light nav-link-hand" [class.active]="activeTab === 'billing'" (click)="activeTab = 'billing'">Billing<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a>
                    </div>
                  </div>
                </nav>


              </div>
            </div>

          </div>

        </div>

      </div>
    </div>
  </div>

  <div class="columnfeatures2">
    <div class="tab-content">
      <div class="tab-pane container margin-left-0px margin-right-0px padding-left-0px padding-right-0px max-width-100pe" [class.active]="activeTab === 'admissiondetails'" [class.show]="activeTab === 'admissiondetails'" [style.display]="activeTab === 'admissiondetails' ? 'block' : 'none'" id="admissiondetails" role="tabpanel">
        <div class="card" *ngIf="ShowList">
          <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px">
            <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
              <div class="col-md-3">
                <label class="margin-bottom-0px margin-left-5px">Admission Details </label>
              </div>
              <!--<div class="col-md-3">
                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
              </div>-->

              <div class="col-md-3">
                <div class="row float-left">
                  <!--<div class="col-md-6 padding-right-0px">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                  </div>-->
                  <div class=" offset-md-3 col-md-9 padding-left-0px">
                    <!--<button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="Payment()"><i class="fas fa-rupee-sign nav-link-hand font-size-12px margin-top-5px"></i> Pay</button>-->
                    <!--<button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" (click)="Cancel()">Cancel </button>-->

                    <button class="btn actions-btn-prime font-size-13px float-right margin-right-5px" (click)="Editlist()">Edit <i class="fas fa-pencil-alt nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>
                <!--<button type="submit" class="btn actions-btn-prime font-size-13px margin-left-5px float-right"><i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print</button>-->



              </div>

            </div>
          </div>

          <div class="card-body  padding-bottom-0px padding-right-0px padding-top-10px" *ngFor="let l of CurrentAdmissionsByCodeController">
            <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission No</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionNo}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Date</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionDate | date:'dd-MMM-yyyy'}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Case Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.CaseType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Treatment Category</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.TreatmentCategory}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Provider Incharge</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.ProviderIncharge}}</label></div>
              </div>
            </div>

            <div class="chatsd product-chart-wrapper product-chat-height-600 agreement-chart-wrapper ps2 padding-lrt">
              <div class="row">
                <div class="col-md-1">

                </div>
                <div class="col-md-11">
                  <div>
                    <form class="form " novalidate="" #f="ngForm">
                      <div class="accordion" id="accordionExample3">
                        <div class="card margin-bottom-5px padding-top-10px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne3">
                            <div class="row">
                              <div class="col-md-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne3" aria-expanded="true" aria-controls="collapseOne3">
                                    Payment Details
                                  </button>
                                </h5>
                              </div>
                            </div>


                          </div>

                          <div id="collapseOne3" class="collapse show" aria-labelledby="headingOne3" data-parent="#accordionExample3">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">IP Advance</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.PaymentReference}}</label>
                                      <!--<input type="text" class="form-control" placeholder="IP Advance"
                                      pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100" />-->

                                    </div>
                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div>
                    <form class="form " novalidate="" #f="ngForm">
                      <div class="accordion" id="accordionExample4">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne4">
                            <div class="row">
                              <div class="col-md-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne4" aria-expanded="true" aria-controls="collapseOne4">
                                    Admit Location
                                  </button>
                                </h5>
                              </div>

                            </div>


                          </div>

                          <div id="collapseOne4" class="collapse show" aria-labelledby="headingOne4" data-parent="#accordionExample4">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Care Unit</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.CareUnit}}</label>
                                      <!--<input type="text" class="form-control" placeholder="Care Unit"
                                      pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100" />-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Bed Location</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.BedLocation}}</label>
                                      <!--<input type="text" class="form-control" placeholder="Bed Location"
                                      pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100" />-->

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Planned Discharged On</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.PlannedDischargeDate | date:'dd-MMM-yyyy'}}</label>
                                      <!--<div class="date-form">
                                        <input class="form-control" placeholder="Planned Discharged On" ngbDatepicker #d2="ngbDatepicker">

                                        <a (click)="d2.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>
                                      </div>-->

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Estimated Stay In Days</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.EstimatedLengthOfStay}}</label>
                                      <!--<input type="text" class="form-control" placeholder="Estimated Stay"
                                      pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100" />-->

                                    </div>

                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div>
                    <form class="form " novalidate="" #f="ngForm">
                      <div class="accordion" id="accordionExample5">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne5">
                            <div class="row">
                              <div class="col-md-7">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne5" aria-expanded="true" aria-controls="collapseOne5">
                                    Patient Consent
                                  </button>
                                </h5>
                              </div>

                            </div>


                          </div>

                          <div id="collapseOne5" class="collapse show" aria-labelledby="headingOne5" data-parent="#accordionExample5">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Signed</label>
                                    </div>


                                    <div class="col-md-3">

                                      <input type="checkbox" class="checkbox2" checked>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Consent Form No</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.ConsentFormNo}}</label>
                                    </div>

                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div>
                    <form class="form " novalidate="" #f="ngForm">
                      <div class="accordion" id="accordionExample6">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne6">
                            <div class="row">
                              <div class="col-md-7">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne6" aria-expanded="true" aria-controls="collapseOne6">
                                    Admission Status
                                  </button>
                                </h5>
                              </div>

                            </div>


                          </div>

                          <div id="collapseOne6" class="collapse show" aria-labelledby="headingOne6" data-parent="#accordionExample6">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Admission Status</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.AdmissionStatus}}</label>
                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Admission Reason</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.AdmissionReason}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Proposed Treatment</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.ProposedTreatment}}</label>
                                    </div>

                                  </div>

                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Proposed Treatment Remarks</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.ProposedTreatmentRemarks}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Procedure Done On</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.ProcedureDoneOn | date:'dd-MMM-yyyy'}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div>
                    <form class="form " novalidate="" #f="ngForm">
                      <div class="accordion" id="accordionExample7">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne7">
                            <div class="row">
                              <div class="col-md-1">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne7" aria-expanded="true" aria-controls="collapseOne7">
                                    Insurance
                                  </button>
                                </h5>
                              </div>
                              <div class="col-md-1">
                                <input type="checkbox" class="checkbox2" checked>

                              </div>
                            </div>


                          </div>

                          <div id="collapseOne7" class="collapse show" aria-labelledby="headingOne7" data-parent="#accordionExample7">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Debtor Type</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.DebtorType}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Insurance Provider</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.InsuranceProvider}}</label>
                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Card No</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.CardNo}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Approval Status</label>
                                    </div>


                                    <div class="col-md-3">
                                      <label class="font-size-14 margin-bottom-0px">{{l.TpiApprovalStatus}}</label>
                                    </div>

                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>


          </div>


        </div>

        <div class="card" *ngIf="EditList">
          <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px">
            <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
              <div class="col-md-3">
                <label class="margin-bottom-0px margin-left-5px">Admission Details </label>
              </div>

              <div class="col-md-2">
                <div class="row">

                  <div class="col-md-12 padding-left-0px">
                    <!--<button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="Payment()"><i class="fas fa-rupee-sign nav-link-hand font-size-12px margin-top-5px"></i> Pay</button>-->
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" (click)="Cancel()">Cancel </button>

                    <button class="btn actions-btn-prime font-size-13px float-right margin-right-5px" (click)="SaveAdmissionDetails()">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>
                <!--<button type="submit" class="btn actions-btn-prime font-size-13px margin-left-5px float-right"><i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print</button>-->



              </div>

            </div>
          </div>
          <div class="card-body  padding-bottom-0px padding-right-0px padding-top-10px" *ngFor="let l of CurrentAdmissionsByCodeController">
            <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission No</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionNo}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Date</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionDate | date:'dd-MMM-yyyy'}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Case Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.CaseType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Treatment Category</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.TreatmentCategory}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Provider Incharge</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.ProviderIncharge}}</label></div>
              </div>
            </div>
            <div class="chatsd product-chart-wrapper product-chat-height-600 agreement-chart-wrapper ps2 padding-lrt">
              <div class="row" *ngIf="SelectedAdmission">
                <div class="col-md-1">

                </div>
                <div class="col-md-11">

                  <div>
                    <form class="form " novalidate="" #f="ngForm">
                      <div class="accordion" id="accordionExample4">
                        <div class="card margin-bottom-5px padding-top-10px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne4">
                            <div class="row">
                              <div class="col-md-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne4" aria-expanded="true" aria-controls="collapseOne4">
                                    Admit Location
                                  </button>
                                </h5>
                              </div>

                            </div>


                          </div>

                          <div id="collapseOne4" class="collapse show" aria-labelledby="headingOne4" data-parent="#accordionExample4">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Care Unit</label>
                                    </div>


                                    <div class="col-md-3">

                                      <input type="text" class="form-control" placeholder="Care Unit"
                                             pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100"
                                             name="SelectedAdmission.CareUnit"
                                             [(ngModel)]="SelectedAdmission.CareUnit" />

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Bed Location</label>
                                    </div>


                                    <div class="col-md-3">

                                      <input type="text" class="form-control" placeholder="Bed Location"
                                             pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100"
                                             name="SelectedAdmission.BedLocation"
                                             [(ngModel)]="SelectedAdmission.BedLocation" />

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Planned Discharged On</label>
                                    </div>


                                    <div class="col-md-3">

                                      <div class="date-form">
                                        <input class="form-control" placeholder="Planned Discharged On" ngbDatepicker #d2="ngbDatepicker">

                                        <a (click)="d2.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>
                                      </div>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Estimated Stay In Days</label>
                                    </div>


                                    <div class="col-md-3">

                                      <input type="text" class="form-control" placeholder="Estimated Stay"
                                             pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100"
                                             name="SelectedAdmission.EstimatedLengthOfStay"
                                             [(ngModel)]="SelectedAdmission.EstimatedLengthOfStay" />

                                    </div>

                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div>
                    <form class="form " novalidate="" #f="ngForm">
                      <div class="accordion" id="accordionExample5">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne5">
                            <div class="row">
                              <div class="col-md-7">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne5" aria-expanded="true" aria-controls="collapseOne5">
                                    Patient Consent
                                  </button>
                                </h5>
                              </div>

                            </div>


                          </div>

                          <div id="collapseOne5" class="collapse show" aria-labelledby="headingOne5" data-parent="#accordionExample5">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Signed</label>
                                    </div>


                                    <div class="col-md-3">

                                      <input type="checkbox" class="checkbox2" checked>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Consent Form No</label>
                                    </div>


                                    <div class="col-md-3">

                                      <input type="text" class="form-control" placeholder="Consent Form No"
                                             pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100"
                                             name="SelectedAdmission.ConsentFormNo"
                                             [(ngModel)]="SelectedAdmission.ConsentFormNo" />

                                    </div>

                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div>
                    <form class="form " novalidate="" #f="ngForm">
                      <div class="accordion" id="accordionExample6">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne6">
                            <div class="row">
                              <div class="col-md-7">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne6" aria-expanded="true" aria-controls="collapseOne6">
                                    Admission Status
                                  </button>
                                </h5>
                              </div>

                            </div>


                          </div>

                          <div id="collapseOne6" class="collapse show" aria-labelledby="headingOne6" data-parent="#accordionExample6">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Admission Status</label>
                                    </div>


                                    <div class="col-md-3">

                                      <CodeTypeValue CodeType="ADMST"
                                                     name="SelectedAdmission.AdmissionStatus"
                                                     [(ngModel)]="SelectedAdmission.AdmissionStatus">
                                      </CodeTypeValue>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Admission Reason</label>
                                    </div>


                                    <div class="col-md-3">

                                      <CodeTypeValue CodeType="ADMRS"
                                                     name="SelectedAdmission.AdmissionReason"
                                                     [(ngModel)]="SelectedAdmission.AdmissionReason">
                                      </CodeTypeValue>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Proposed Treatment</label>
                                    </div>


                                    <div class="col-md-3">
                                      <input type="text" class="form-control" placeholder="Proposed Treatment"
                                             pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100"
                                             name="SelectedAdmission.ProposedTreatment"
                                             [(ngModel)]="SelectedAdmission.ProposedTreatment" />
                                      <!--<label class="font-size-14 margin-bottom-0px" *ngIf="PrimaryDoctorn">{{PrimaryDoctor}}</label>
                                      <label class="font-size-14 margin-bottom-0px" *ngIf="PrimaryDoctorO">{{PrimaryDoctor}}</label>-->
                                    </div>
                                    <!--<div class="col-md-1">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectPrimaryDoctor()"> <i class="fas fa-ellipsis-h"></i></button>
                                    </div>-->

                                  </div>

                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Proposed Treatment Remarks</label>
                                    </div>


                                    <div class="col-md-3">

                                      <input type="text" class="form-control" placeholder="Proposed Treatment Remarks"
                                             pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100"
                                             name="SelectedAdmission.ProposedTreatmentRemarks"
                                             [(ngModel)]="SelectedAdmission.ProposedTreatmentRemarks" />

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Procedure Done On</label>
                                    </div>


                                    <div class="col-md-3">

                                      <div class="date-form">
                                        <input class="form-control" placeholder="Procedure Done On" ngbDatepicker #d3="ngbDatepicker">

                                        <a (click)="d3.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>
                                      </div>

                                    </div>

                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div>
                    <form class="form " novalidate="" #f="ngForm">
                      <div class="accordion" id="accordionExample7">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne7">
                            <div class="row">
                              <div class="col-md-1">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne7" aria-expanded="true" aria-controls="collapseOne7">
                                    Insurance
                                  </button>
                                </h5>
                              </div>
                              <div class="col-md-1">
                                <input type="checkbox" class="checkbox2" (click)="toggle()">

                              </div>
                            </div>


                          </div>

                          <div id="collapseOne7" class="collapse show" aria-labelledby="headingOne7" data-parent="#accordionExample7" *ngIf="Insurancetoggle">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Debtor Type</label>
                                    </div>


                                    <div class="col-md-3">

                                      <CodeTypeValue CodeType="DBRTY"
                                                     name="SelectedAdmission.DebtorType"
                                                     [(ngModel)]="SelectedAdmission.DebtorType">
                                      </CodeTypeValue>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Insurance Provider</label>
                                    </div>


                                    <div class="col-md-3">

                                      <CodeTypeValue CodeType="INLST"
                                                     name="SelectedAdmission.InsuranceProvider"
                                                     [(ngModel)]="SelectedAdmission.InsuranceProvider">
                                      </CodeTypeValue>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Card No</label>
                                    </div>


                                    <div class="col-md-3">

                                      <input type="text" class="form-control" placeholder="Card No"
                                             pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100"
                                             name="SelectedAdmission.CardNo"
                                             [(ngModel)]="SelectedAdmission.CardNo" />

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Approval Status</label>
                                    </div>


                                    <div class="col-md-3">

                                      <CodeTypeValue CodeType="APSTA"
                                                     name="SelectedAdmission.TpiApprovalStatus"
                                                     [(ngModel)]="SelectedAdmission.TpiApprovalStatus">
                                      </CodeTypeValue>

                                    </div>

                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

            </div>
          </div>


        </div>
      </div>

      <div class="tab-pane container margin-left-0px margin-right-0px padding-left-0px padding-right-0px max-width-100pe" [class.active]="activeTab === 'services'" [class.show]="activeTab === 'services'" [style.display]="activeTab === 'services' ? 'block' : 'none'" id="services" role="tabpanel">

        <div class="card">
          <div class="card-header wh-header background-lightblue padding-bottom-0px padding-left-0px padding-right-0px padding-top-0px">
            <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
              <div class="col-md-3">
                <label class="margin-bottom-0px margin-left-5px">Services </label>
              </div>

            </div>
          </div>

          <div class="card-body  padding-bottom-0px padding-right-0px padding-left-0px padding-top-0px" *ngFor="let l of CurrentAdmissionsByCodeController">
            <div class="row border-top border-bottom bk-lt-gray margin-left-0px margin-right-0px">
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission No</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionNo}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Date</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionDate | date:'dd-MMM-yyyy'}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Case Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.CaseType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Treatment Category</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.TreatmentCategory}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Provider Incharge</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.ProviderIncharge}}</label></div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">

              </div>
            </div>



          </div>


        </div>

        <!--<div *ngIf="SelectedPatientFormattedCode">
          <servicesadmission [ActorCode]="SelectedPatientFormattedCode.ActorCode" [FormattedCode]="SelectedPatientFormattedCode.FormattedCode" [PatientCode]="SelectedPatientFormattedCode.PatientRegistrationNumber"></servicesadmission>

        </div>-->
        <div *ngFor="let l of CurrentAdmissionsByCodeController">
          <!--<servicesadmission [AdmissionNo]="l.AdmissionNo" [AdmissionDate]="l.AdmissionDate" [CareUnit]="l.CareUnit"
                             [BedLocation]="l.BedLocation" [PatientName]="l.PatientName" [TreatmentCategory]="l.TreatmentCategory"
                             [PatientFormattedCode]="l.PatientFormattedCode">

          </servicesadmission>-->

          <servicesadmission [SelectedAdmission]="l">

          </servicesadmission>

        </div>
      </div>

      <div class="tab-pane container margin-left-0px margin-right-0px padding-left-0px padding-right-0px max-width-100pe" [class.active]="activeTab === 'medicines'" [class.show]="activeTab === 'medicines'" [style.display]="activeTab === 'medicines' ? 'block' : 'none'" id="medicines" role="tabpanel">

        <div class="card">
          <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px">
            <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
              <div class="col-md-3">
                <label class="margin-bottom-0px margin-left-5px">Medicines </label>
              </div>

            </div>
          </div>

          <div class="card-body  padding-bottom-0px padding-right-0px padding-top-10px" *ngFor="let l of CurrentAdmissionsByCodeController">
            <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission No</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionNo}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Date</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionDate | date:'dd-MMM-yyyy'}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Case Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.CaseType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Treatment Category</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.TreatmentCategory}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Provider Incharge</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.ProviderIncharge}}</label></div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">

              </div>
            </div>



          </div>


        </div>

        <div *ngIf="SelectedPatientFormattedCode">
          <medicinesadmission [ActorCode]="SelectedPatientFormattedCode.ActorCode" [FormattedCode]="SelectedPatientFormattedCode.FormattedCode" [PatientCode]="SelectedPatientFormattedCode.PatientRegistrationNumber"></medicinesadmission>

        </div>

      </div>

      <div class="tab-pane container margin-left-0px margin-right-0px padding-left-0px padding-right-0px max-width-100pe" [class.active]="activeTab === 'consumption'" [class.show]="activeTab === 'consumption'" [style.display]="activeTab === 'consumption' ? 'block' : 'none'" id="consumption" role="tabpanel">

        <div class="card">
          <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px">
            <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
              <div class="col-md-3">
                <label class="margin-bottom-0px margin-left-5px">Consumption </label>
              </div>

            </div>
          </div>

          <div class="card-body  padding-bottom-0px padding-right-0px padding-top-10px" *ngFor="let l of CurrentAdmissionsByCodeController">
            <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission No</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionNo}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Date</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionDate | date:'dd-MMM-yyyy'}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Case Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.CaseType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Treatment Category</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.TreatmentCategory}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Provider Incharge</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.ProviderIncharge}}</label></div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">

              </div>
            </div>



          </div>


        </div>

      </div>

      <div class="tab-pane container margin-left-0px margin-right-0px padding-left-0px padding-right-0px max-width-100pe" id="discharge" role="tabpanel">

        <div class="card">
          <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px">
            <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
              <div class="col-md-3">
                <label class="margin-bottom-0px margin-left-5px">Discharges </label>
              </div>

            </div>
          </div>

          <div class="card-body  padding-bottom-0px padding-right-0px padding-top-10px" *ngFor="let l of CurrentAdmissionsByCodeController">
            <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission No</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionNo}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Date</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionDate | date:'dd-MMM-yyyy'}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Case Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.CaseType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Treatment Category</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.TreatmentCategory}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Provider Incharge</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.ProviderIncharge}}</label></div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-1">

              </div>
              <div class="col-md-11">

                <!--initiation-->
                <div>
                  <form class="form " novalidate="" #f="ngForm" *canUserAccess="['HL_ADT_DISC_INI']">
                    <div class="accordion" id="accordionExample41">
                      <div class="card margin-bottom-5px padding-top-10px">
                        <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne41">
                          <div class="row">
                            <div class="col-md-4">
                              <h5 class="mb-0 height-24px">
                                <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne41" aria-expanded="true" aria-controls="collapseOne41">
                                  Discharge Initiation
                                </button>
                              </h5>
                            </div>

                          </div>


                        </div>

                        <div id="collapseOne41" class="collapse show" aria-labelledby="headingOne41" data-parent="#accordionExample41">
                          <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Is Initiated</label>
                                  </div>


                                  <div class="col-md-3 margin-bottom-10px">
                                    <!--put a tick mark , if discharge initiated-->

                                    <!--<input type="checkbox" class="checkbox2"
                                           [(ngModel)]="CurrentDischargeDetailsController.IsDischargeInitiated"
                                           [ngModelOptions]="{standalone: true}">-->
                                    <i class="fa fa-check tick-mark-styles color-green float-left"
                                       *ngIf="AdmissionHeader2 && AdmissionHeader2.IsDischargeInitiated"></i>
                                    <label class="margin-bottom-0px margin-top-5px"
                                           *ngIf="AdmissionHeader2 && !AdmissionHeader2.IsDischargeInitiated">--</label>
                                  </div>

                                </div>


                              </div>
                            </div>
                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Initiated By</label>
                                  </div>


                                  <div class="col-md-3" *ngIf="AdmissionHeader2 && !AdmissionHeader2.IsDischargeInitiated">

                                    <CustomDataByRequestType RequestedType="EmployeeActorCodeByFacility" ActorCode={{ActorCode}} FacilityCode={{FacilityCode}}
                                                             (keyChange)="Roleassignemp($event)"
                                                             [(ngModel)]="SelectedEmployeeCode" name="SelectedEmployeeCode"
                                                             required>
                                    </CustomDataByRequestType>


                                  </div>

                                  <div class="col-md-3" *ngIf="AdmissionHeader2 && AdmissionHeader2.IsDischargeInitiated">
                                    <label for="diaplayName"
                                           class="font-size-12px margin-bottom-0px"
                                           *ngIf="DischargeDetails && DischargeDetails.DischargeInitiatedUser">
                                      {{DischargeDetails.DischargeInitiatedUser}}
                                    </label>
                                  </div>

                                </div>


                              </div>
                            </div>                           
                            

                            <div class="row">
                              
                                <div class="col-md-3">

                                </div>
                                <div class="col-md-3" *ngIf="AdmissionHeader2 && !AdmissionHeader2.IsDischargeInitiated">
                                  <!--<div class="col-md-3">-->
                                    <button type="button" (click)="DischargeInitiation()"
                                            class="btn actions-btn-prime font-size-13px margin-right-5px">
                                      Begin Discharge Process
                                    </button>
                                  
                                </div>

                              
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>


                
                <div *ngIf="AdmissionHeader2 &&  AdmissionHeader2.IsDischargeInitiated">                  
                  <form class="form " novalidate="" #f="ngForm" *canUserAccess="['HL_ADT_DISC_APPR']">
                    <div class="accordion" id="accordionExample51">
                      <div class="card margin-bottom-5px">
                        <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne51">
                          <div class="row">
                            <div class="col-md-7">
                              <h5 class="mb-0 height-24px">
                                <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne51" aria-expanded="true" aria-controls="collapseOne51">
                                  Discharge Approval
                                </button>
                              </h5>
                            </div>

                          </div>


                        </div>

                        <div id="collapseOne51" class="collapse show" aria-labelledby="headingOne51" data-parent="#accordionExample51">
                          <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Is Approved</label>
                                  </div>


                                  <div class="col-md-3 margin-bottom-10px">

                                    <i class="fa fa-check tick-mark-styles color-green float-left"
                                       *ngIf="DischargeDetails && DischargeDetails.ClearanceStatus =='DSCOK'"></i>
                                    <label class="margin-bottom-0px margin-top-5px"
                                           *ngIf="DischargeDetails && DischargeDetails.ClearanceStatus !=='DSCOK'">--</label>

                                  </div>

                                </div>


                              </div>
                            </div>

                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Approved By</label>
                                  </div>

                                  <div class="col-md-3" *ngIf="DischargeDetails && DischargeDetails.ClearanceStatus !=='DSCOK'">

                                    <select class="form-control padding-left-10px padding-right-0px" (change)="onChange2($event.target)">
                                      <option selected="selected" value=""></option>
                                      <option *ngFor="let l of CurrentDoctorsListController" [value]="l.ProviderCode">
                                        {{l.Prefix}}{{l.DisplayName}}
                                      </option>
                                    </select>


                                  </div>

                                  <div class="col-md-3"*ngIf="DischargeDetails && DischargeDetails.ClearanceStatus =='DSCOK'">

                                    <label for="diaplayName"
                                           class="font-size-12px margin-bottom-0px"
                                           *ngIf="DischargeDetails && DischargeDetails.DischargeApprovedUser">
                                      {{DischargeDetails.DischargeApprovedUser}}
                                    </label>

                                  </div>

                                </div>


                              </div>
                            </div>

                            <div class="row">                              
                                <div class="col-md-3">

                                </div>
                                <div class="col-md-3" *ngIf="DischargeDetails && DischargeDetails.ClearanceStatus !=='DSCOK'">                                  
                                    <button type="button" (click)="DischargeApproval()" class="btn actions-btn-prime font-size-13px margin-right-5px">
                                      Approve Discharge
                                    </button>                                  
                                </div>                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>


                
                <div *ngIf="AdmissionHeader2 &&  AdmissionHeader2.IsDischargeInitiated">                  
                  <form class="form " novalidate="" #f="ngForm" *canUserAccess="['HL_ADT_DISC_FINAL']">
                    <div class="accordion" id="accordionExample61">
                      <div class="card margin-bottom-5px">
                        <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne61">
                          <div class="row">
                            <div class="col-md-7">
                              <h5 class="mb-0 height-24px">
                                <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne61" aria-expanded="true" aria-controls="collapseOne61">
                                  Discharge Closure
                                </button>
                              </h5>
                            </div>

                          </div>


                        </div>

                        <div id="collapseOne61" class="collapse show" aria-labelledby="headingOne61" data-parent="#accordionExample61">
                          <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Is Discharged</label>
                                  </div>


                                  <div class="col-md-3 margin-bottom-10px">

                                    <i class="fa fa-check tick-mark-styles color-green float-left"
                                       *ngIf="AdmissionHeader2 && AdmissionHeader2.IsDischarged"></i>
                                    <label class="margin-bottom-0px"
                                           *ngIf="AdmissionHeader2 && !AdmissionHeader2.IsDischarged">--</label>

                                  </div>

                                </div>


                              </div>
                            </div>

                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Is Against Med Advice</label>
                                  </div>


                                  <div class="col-md-3" *ngIf="!AdmissionHeader2.IsDischarged">

                                    <input type="checkbox" class="checkbox2"
                                           [(ngModel)]="IsDiscAgainstMedAdvise"
                                           [ngModelOptions]="{standalone: true}">

                                  </div>

                                  <div class="col-md-3 margin-bottom-10px" *ngIf="AdmissionHeader2.IsDischarged">

                                    <i class="fa fa-check tick-mark-styles color-green float-left"
                                       *ngIf="DischargeDetails && DischargeDetails.DischargeAgainstAdvice"></i>
                                    <label class="margin-bottom-0px"
                                           *ngIf="DischargeDetails && !DischargeDetails.DischargeAgainstAdvice">--</label>

                                  </div>

                                </div>


                              </div>
                            </div>
                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Discharge Physician</label>
                                  </div>

                                  <div class="col-md-3" *ngIf="!AdmissionHeader2.IsDischarged">

                                    <select class="form-control padding-left-10px padding-right-0px" (change)="onChange($event.target)">
                                      <option selected="selected" value=""></option>
                                      <option *ngFor="let l of CurrentDoctorsListController" [value]="l.ProviderCode">
                                        {{l.Prefix}}{{l.DisplayName}}
                                      </option>
                                    </select>

                                  </div>

                                  <div class="col-md-3" *ngIf="AdmissionHeader2.IsDischarged">

                                    <label for="diaplayName"
                                           class="font-size-12px margin-bottom-0px"
                                           *ngIf="DischargeDetails && DischargeDetails.DischargingPhysicianName">
                                      {{DischargeDetails.DischargingPhysicianName}}
                                    </label>

                                  </div>

                                </div>


                              </div>
                            </div>
                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Discharge Date</label>
                                  </div>


                                  <div class="col-md-3" *ngIf="!AdmissionHeader2.IsDischarged">

                                    <div class="date-form">
                                      <input class="form-control" placeholder="Discharge Date" ngbDatepicker #d3="ngbDatepicker"
                                             name="DischargeDate" [(ngModel)]="DischargeDate">

                                      <a (click)="d3.toggle()" class="nav-link-hand">
                                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                      </a>
                                    </div>

                                  </div>

                                  <div class="col-md-3" *ngIf="AdmissionHeader2.IsDischarged">

                                    <label for="diaplayName"
                                           class="font-size-12px margin-bottom-0px"
                                           *ngIf="DischargeDetails && DischargeDetails.DischargeInitiatedDate">
                                      {{DischargeDetails.DischargeInitiatedDate | date:'dd-MMM-yyyy'}}
                                    </label>

                                  </div>

                                </div>


                              </div>
                            </div>

                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Remarks</label>
                                 </div>
                               
                                  <div class="col-md-3" *ngIf="!AdmissionHeader2.IsDischarged">
                                    <input type="text" class="form-control" placeholder="Remarks"
                                           id="Remarks"
                                           [(ngModel)]="Remarks"
                                           name="Remarks"
                                           pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100" />

                                  </div>

                                  <div class="col-md-3" *ngIf="AdmissionHeader2.IsDischarged">

                                    <label for="diaplayName"
                                           class="font-size-12px margin-bottom-0px"
                                           *ngIf="DischargeDetails && DischargeDetails.Remarks">
                                      {{DischargeDetails.Remarks}}
                                    </label>

                                  </div>

                                </div>

                              </div>
                            </div>

                            <div class="row" *ngIf="!AdmissionHeader2.IsDischarged" >

                              <div class="col-md-3">

                              </div>
                              <div class="col-md-6">
                                <div class="row">
                                  <div class="display-inline">
                                    <button type="button" (click)="DischargeClosure()" class="btn actions-btn-prime font-size-13px margin-right-5px">
                                      Discharge Complete
                                    </button>
                                  </div>
                                  <div class="display-inline" *canUserAccess="['HL_ADT_DISC_FINAL_AMA']">
                                    <button type="button" (click)="DischargeClosure2()" class="btn actions-btn-prime font-size-13px margin-right-5px">
                                      Discharge Against Med Advise
                                    </button>
                                  </div>
                                </div>
                              </div>


                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

              </div>
            </div>



          </div>


        </div>

      </div>



      <div class="tab-pane container margin-left-0px margin-right-0px padding-left-0px padding-right-0px max-width-100pe" [class.active]="activeTab === 'billing'" [class.show]="activeTab === 'billing'" [style.display]="activeTab === 'billing' ? 'block' : 'none'" id="billing" role="tabpanel">

        <div class="card">
          <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px">
            <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
              <div class="col-md-3">
                <label class="margin-bottom-0px margin-left-5px">Billing </label>
              </div>

            </div>
          </div>

          <div class="card-body  padding-bottom-0px padding-right-0px padding-top-10px" *ngFor="let l of CurrentAdmissionsByCodeController">
            <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission No</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionNo}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Date</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionDate | date:'dd-MMM-yyyy'}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Admission Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.AdmissionType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Case Type</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.CaseType}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Treatment Category</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.TreatmentCategory}}</label></div>
              </div>
              <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Provider Incharge</label></div>
                <div><label class="margin-bottom-0px font-size-14">{{l.ProviderIncharge}}</label></div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">

              </div>
            </div>



          </div>


        </div>

        <div *ngIf="SelectedPatientFormattedCode && SelectedAdmission">
          <billadmission [ActorCode]="SelectedPatientFormattedCode.ActorCode" [FormattedCode]="SelectedPatientFormattedCode.FormattedCode"
                         [AdmissionCode]="SelectedAdmission.AdmissionNo" [AdmissionDate]="SelectedAdmission.AdmissionDate"
                         [ProviderIncharge]="SelectedAdmission.ProviderIncharge" [AdmissionCode2]="SelectedAdmission.AdmissionCode"
                         [RefDet]="SelectedAdmission.ReferralDetails" [RefDoc]="SelectedAdmission.ReferralPhysicianName"
                         [FacilityCode]="SelectedPatientFormattedCode.FacilityCode"></billadmission>
          <!--<billadmission [ActorCode]="SelectedPatientFormattedCode.ActorCode" [FormattedCode]="SelectedPatientFormattedCode.FormattedCode"
                         [AdmissionCode]="SelectedAdmission.AdmissionNo" [AdmissionDate]="SelectedAdmission.AdmissionDate"
                         [ProviderIncharge]="SelectedAdmission.ProviderIncharge" [AdmissionCode2]="SelectedAdmission.AdmissionCode"
                         [RefDet]="SelectedAdmission.ReferralDetails" [RefDoc]="SelectedAdmission.ReferralPhysicianName"
                         [Admission]="Admission" [FacilityCode]="SelectedPatientFormattedCode.FacilityCode"></billadmission>-->
        </div>

      </div>

    </div>
  </div>


</div>
